import { ListSearch } from './list-search.model';

export class RunSearchOptions {
    filesToChooseFromSearchOptions: ListSearch | undefined;
    selectedFilesCurrentSearchOptions: ListSearch | undefined;
}
